import { useDispatch } from "react-redux";

import StartWorkBox from "components/StartWorkBox";
import { getVorExampleXslx } from "slices/vor";

const VorEmpty = () => {
	const dispatch = useDispatch();
	const text = (
		<div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
			<div>{`Для начала работы загрузите сметную документацию в формате GGE (в верхнем левом углу по кнопке "Импорт")`}</div>
			<div>{`или выберите сметный расчет в дереве структуры проекта.`}</div>
			<div onClick={() => dispatch(getVorExampleXslx())} style={{ fontWeight: 600, textDecoration: "underline", cursor: "pointer" }}>
				Скачать пример в формате Excel
			</div>
		</div>
	);

	return <StartWorkBox text={text} />;
};

export default VorEmpty;
